<template>
  <div class="cv-iframe-section" :class="{ 'cv-iframe-section--expanded': expandCVSection }">
    <h1 class="cv-iframe-section__title">
      CV
      <em
        v-if="!expandCVSection"
        class="cv-iframe-section__expand-icon fas fa-expand-alt"
        @click="expandCVSection = true"
      ></em>
      <em
        v-if="expandCVSection"
        class="cv-iframe-section__expand-icon fas fa-compress-alt"
        @click="expandCVSection = false"
      ></em>
    </h1>

    <iframe
      :src="`data:application/pdf;base64,${cvAsBase64}`"
      border="0"
      cellspacing="0"
      title="CV"
    />

    <br /><br />
  </div>
</template>

<script>
export default {
  props: {
    cvAsBase64: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      expandCVSection: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.cv-iframe-section {
  transition: 0.2s all;

  .cv-iframe-section__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cv-iframe-section__expand-icon {
    color: $elUIPrimary;
    cursor: pointer;
    transition: 0.2s all;

    &:hover {
      color: $elUIPrimaryHovered;
      transform: scale(1.2);
    }
  }

  iframe {
    height: 400px;
    border-style: none;
    width: 100%;
    border-radius: 4px;

    @media (max-width: 1024px) {
      height: 250px;
    }
  }

  &.cv-iframe-section--expanded {
    position: fixed;
    width: 98%;
    max-width: 1250px;
    height: 94%;
    top: 3%;
    left: calc((100vw - 1250px) / 2);
    z-index: 111;
    background: $appBackgroundColor;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid $borderColor;
    border-radius: 4px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.22);

    iframe {
      height: 90%;
    }

    @media (max-width: 1300px) {
      height: 96%;
      top: 2%;
      left: 1%;
    }
  }
}
</style>
